import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEye, FiMapPin, FiPhone, FiMail, FiClock, FiFacebook, FiInstagram } = FiIcons;

const Footer = () => {
  const quickLinks = [
    { name: 'Eye Tests', href: '#services' },
    { name: 'Frame Collections', href: '#catalog' },
    { name: 'Contact Lenses', href: '#services' },
    { name: 'Repairs', href: '#services' },
    { name: 'About Us', href: '#about' },
    { name: 'Book Appointment', href: '/booking' }
  ];

  const brands = [
    'Ray-Ban', 'Vogue', 'Armani Exchange', 'Elle', 'Che', 'Versace'
  ];

  return (
    <footer className="relative mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center space-x-3 mb-6">
              <div className="glass-icon">
                <SafeIcon icon={FiEye} className="text-2xl text-blue-400" />
              </div>
              <span className="text-xl font-bold text-white">
                Mahanama Opticians
              </span>
            </div>
            <p className="text-white/70 mb-6 leading-relaxed">
              Embilipitiya's trusted eye care center, providing comprehensive vision solutions 
              and premium eyewear for over 15 years.
            </p>
            <div className="flex space-x-4">
              <motion.a
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                href="#"
                className="glass-icon"
              >
                <SafeIcon icon={FiFacebook} className="text-xl text-blue-400" />
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                href="#"
                className="glass-icon"
              >
                <SafeIcon icon={FiInstagram} className="text-xl text-blue-400" />
              </motion.a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
          >
            <h3 className="text-xl font-bold text-white mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <motion.a
                    href={link.href}
                    whileHover={{ x: 5 }}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {link.name}
                  </motion.a>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Brands */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h3 className="text-xl font-bold text-white mb-6">Our Brands</h3>
            <ul className="space-y-3">
              {brands.map((brand) => (
                <li key={brand}>
                  <span className="text-white/70">{brand}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <h3 className="text-xl font-bold text-white mb-6">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-white/70">No 65/C New Town Road</p>
                  <p className="text-white/70">Embilipitiya, Sri Lanka</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-blue-400 flex-shrink-0" />
                <p className="text-white/70">+94 47 2 260 123</p>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="text-blue-400 flex-shrink-0" />
                <p className="text-white/70">info@mahanamaopticians.lk</p>
              </div>
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiClock} className="text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-white/70">Mon - Sat: 9:00 AM - 6:00 PM</p>
                  <p className="text-white/70">Sunday: Closed</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center"
        >
          <p className="text-white/70 mb-4 md:mb-0">
            © 2025 Mahanama Opticians. Designed and Created by Rajantha
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-white/70 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-white/70 hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;